import { useState, useEffect, useMemo, useCallback } from 'react';
import _debounce from 'lodash/debounce';

export const useContainerDimensions = myRef => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const handleResize = useCallback(() => {
    if (myRef.current) {
      setDimensions({
        width: myRef.current.offsetWidth,
        height: myRef.current.offsetHeight,
      });
    }
  }, [myRef]);

  const debounceFn = useMemo(() => _debounce(handleResize, 500), [handleResize]);

  useEffect(() => {
    if (myRef.current) {
      handleResize();
    }
  }, []);

  useEffect(() => {
    window.addEventListener('resize', debounceFn);
    return () => {
      window.removeEventListener('resize', debounceFn);
    };
  }, [debounceFn]);

  return dimensions;
};

export default useContainerDimensions;
